import type { FC, ReactNode } from 'react';
import type { PickProps } from '@/ui/types/types';
import { Flex, Typography } from '@ui';
import { useId } from 'react';
import styles from './Statistic.module.css';

type Props = {
    title: ReactNode;
    value: number;
} & PickProps<'div', 'ref'>;

export const Statistic: FC<Props> = ({ title, value, ...props }) => {
    const titleId = useId();
    const valueId = useId();
    return (
        <Flex
            align="center"
            gap={24}
            aria-labelledby={titleId}
            aria-describedby={valueId}
            className={styles.container}
            {...props}
        >
            <Typography.Heading id={titleId} level={4}>{title}</Typography.Heading>
            <div className={styles.value}>
                <Typography.Display id={valueId} level={1}>{value}</Typography.Display>
            </div>
        </Flex>
    );
};
